import { render } from "./StageRegions.vue?vue&type=template&id=0dc73182&scoped=true"
import script from "./StageRegions.vue?vue&type=script&lang=js"
export * from "./StageRegions.vue?vue&type=script&lang=js"

import "./StageRegions.vue?vue&type=style&index=0&id=0dc73182&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc73182"]])

export default __exports__